<template>
  <div
    :class="
      mqShallShowRightSidebar
        ? 'sidebar-right active'
        : 'sidebar-right in-active'
    "
  >
    <!--  <div class="sidebar-right">-->

    <!-- Sidebar Content -->
    <div
      class="sidebar-content right-sidebar-content"
      :class="{
        show: mqShallShowRightSidebar,
        'zero-width': !mqShallShowRightSidebar,
      }"
    >
      <!-- Sidebar close icon -->
      <!-- <span class="sidebar-close-icon">
        <feather-icon icon="XIcon" size="16" :class="{ 'd-none': !mqShallShowRightSidebar }"
          @click="$emit('update:mq-shall-show-right-sidebar', false)" />
      </span> -->

      <!-- Header -->

      <div class="tab-container">
        <b-tabs content-class="mt-0" v-model="tabIndex">
          <!-- loop here's  -->
          <b-tab
            v-for="(profile, index) in activeRoom.meta"
            :key="profile.id"
            :title="profile.name"
          >
            <div class="tree-node accordion" role="tablist">
              <b-card no-body class="mb-0">
                <b-card-header header-tag="header" variant="info">
                  <div class="personal-info pt-0" style="width: 100%">
                    <div class="list-unstyled mb-2">
                      <!--Visitor Section-->
                      <h6 class="section-label mb-2">
                        {{ $t("general.profileInfo") }}
                      </h6>
                      <!-- {{ profile }} -->
                      <div style="display: grid; gap: 1em">
                        <EditableLabel
                          icon="HashIcon"
                          :default-data="
                            profile.id ? profile.id : $t('ticket.na')
                          "
                        />

                        <EditableLabel
                          icon="UserIcon"
                          :default-data="
                            profile.name ? profile.name : $t('ticket.na')
                          "
                        />

                        <EditableLabel
                          icon="MapPinIcon"
                          placeholder="Enter Name"
                          :default-data="
                            profile.timezone
                              ? profile.timezone
                              : $t('ticket.na')
                          "
                        />

                        <EditableLabel
                          icon="MonitorIcon"
                          placeholder="Enter Name"
                          :default-data="
                            profile.device ? profile.device : $t('ticket.na')
                          "
                        />

                        <EditableLabel
                          icon="StopCircleIcon"
                          placeholder="Enter Name"
                          :default-data="
                            profile.ip ? profile.ip : $t('ticket.na')
                          "
                        />

                        <!-- <EditableLabel
                          icon="AlertCircleIcon"
                          default-data="N/A"
                        /> -->
                      </div>

                      <!--Assigned Section-->
                      <!-- <h6 class="section-label mb-2 mt-2">
                        {{ $t("chat.assign") }}
                      </h6>
                      <div>
                        <div v-if="activeRoom" class="mb-1">
                          <span class="align-middle">
                            <feather-icon icon="MessageCircleIcon" size="20" class="mr-50" />
                            {{ $t("ticket.assign") }}:
                            {{
                              activeRoom.merchantUserName ||
                              $t("ticket.no_information")
                            }}
                          </span>
                        </div>

                        <div v-if="activeRoom" class="mb-1">
                          <span class="align-middle">
                            <feather-icon icon="FlagIcon" size="20" class="mr-50" />
                            {{ $t("ticket.status") }}: {{ statusLabel }}
                          </span>
                        </div>
                      </div> -->
                    </div>
                  </div>
                  <!-- <div v-if="activeRoom.rateData" class="personal-info">
                    <h6 class="section-label mb-1">
                      {{ $t("chat.rating") }}
                    </h6>
                    <ul class="list-unstyled">
                      <li class="mb-1">
                        <feather-icon v-for="i in 5" :key="`star-${i}`" icon="StarIcon" size="22" class="rating-star mr-1"
                          :class="{
                            active: i <= activeRoom.rateData.rate,
                          }" />
                      </li>
                      <li v-if="activeRoom.customer" class="mb-1">
                        {{ activeRoom.rateData.comment }}
                      </li>
                    </ul>
                  </div> -->
                </b-card-header>
                <b-card-body />
              </b-card>
            </div>
          </b-tab>
        </b-tabs>
        <div style="margin: 20px">
          <!-- <TicketHistory
            :roomId="activeRoom.roomId"
            :isPrivateChat="true"
            :email="visitorInformation.email || ''"
            :history="chatMeTicketHistory"
            :loading="ticketStore.loading.isSubmitting"
            :options="ticketStore.getOptions"
            @submit-respond="handleSubmitRespond"
            @submit="
              (createForm) => ticketStore.createTicketAsync(createForm, null)
            "
          /> -->
        </div>

        <!--end loop here's  -->

        <!-- <b-tab :title="$t('breadcrumb.quickMessage')">
            <div class="chat-fixed-search">
              <div class="d-flex align-items-center w-100">
                Search 
                <b-input-group v-show="isShowSearch" class="input-group-merge ml-1 w-100 round">
                  <b-input-group-prepend is-text>
                    <feather-icon icon="SearchIcon" class="text-muted" />
                  </b-input-group-prepend>
                  <b-form-input v-model="query.search" v-debounce:0ms="search" :placeholder="$t('general.search')" />
                </b-input-group>
                <div v-show="!isShowSearch" class="chat-filter">
                  <div class="filter">
                    <h6 class="cursor-pointer" :class="{
                      active: option.value == query.filter,
                    }" v-for="option in tabOptions" :key="option.value" @click="changeFilter(option.value)">
                      {{ $t(option.text) }}
                    </h6>
                    <h3>{{ $t('text.Menu') }}</h3>
                  </div>
                </div>

                <feather-icon
                  icon="SearchIcon"
                  size="22"
                  class="ml-1 cursor-pointer"
                  :class="{
                    'text-primary': isShowSearch,
                  }"
                  @click="searching"
                />
              </div>
            </div>
            Team
            <div>
              <div class="tree-node accordion" role="tablist">
                <b-card no-body class="mb-0">
                  <b-card-header v-b-toggle.accordion-1 header-tag="header" class="node-header" block variant="info">
                    <feather-icon v-if="!visible" v-b-tooltip.hover class="float-right" size="20"
                      icon="ChevronRightIcon" />
                    <feather-icon v-if="visible" v-b-tooltip.hover icon="ChevronDownIcon" size="20" class="float-right" />
                    <p v-for="option in filterOptions" :key="option.value" class=""
                      style="margin-bottom: unset; padding: 0.25em 0" @click="changeFilter(option.value)">
                      {{ option.textTeam }}
                    </p>
                  </b-card-header>
                  <b-collapse id="accordion-1" v-model="visible" visible accordion="my-accordion" role="tabpanel">
                    <b-card-body>
                      <div class="position-relative chat-contact-wrapper">
                        <div class="chat-user-list-wrapper list-group scroll-area overflow-y py-1">
                          <div v-if="loading" slot="spinner" class="mt-2 mx-auto">
                            <b-spinner label="Spinning" />
                          </div>
                          <div v-if="!loading && items.length === 0" slot="spinner" class="mt-2 mx-auto">
                            {{ $t("general.noRecord") }}
                          </div>
                          <tree-node v-for="item in items" :key="item.id" :node="item"
                            :send-text-message="sendTextMessage" :active-channel="activeRoom" />
                        </div>
                      </div>
                    </b-card-body>
                  </b-collapse>
                </b-card>
              </div>
            </div>
             Personal
            <div>
              <div class="tree-node accordion" role="tablist">
                <b-card no-body class="mb-0">
                  <b-card-header v-b-toggle.accordion-2 header-tag="header" class="node-header" role="tab" block
                    variant="info">
                    <feather-icon v-if="!visiblePersonal" v-b-tooltip.hover class="float-right" size="20"
                      icon="ChevronRightIcon" />
                    <feather-icon v-if="visiblePersonal" v-b-tooltip.hover icon="ChevronDownIcon" size="20"
                      class="float-right" />
                    <p v-for="option in filterOptions" :key="option.value" class=""
                      style="margin-bottom: unset; padding: 0.25em 0" @click="changeFilter(option.value)">
                      {{ option.textPersonal }}
                    </p>
                  </b-card-header>
                  <b-collapse id="accordion-2" v-model="visiblePersonal" accordion="my-accordion" role="tabpanel">
                    <b-card-body>
                      <div class="position-relative chat-contact-wrapper">
                        <div class="chat-user-list-wrapper list-group scroll-area overflow-y py-1">
                          <div v-if="loading" slot="spinner" class="mt-2 mx-auto">
                            <b-spinner label="Spinning" />
                          </div>
                          <div v-if="!loading && items.length === 0" slot="spinner" class="mt-2 mx-auto">
                            {{ $t("general.noRecord") }}
                          </div>
                          <tree-node v-for="item in items" :key="item.id" :node="item"
                            :send-text-message="sendTextMessage" :active-channel="activeRoom" />
                        </div>
                      </div>
                    </b-card-body>
                  </b-collapse>
                </b-card>
              </div>
            </div>
          </b-tab> -->
      </div>
    </div>
  </div>
</template>

<script>
import {
  BAvatar,
  BForm,
  BInputGroup,
  BInputGroupPrepend,
  BFormInput,
  BButton,
  BSpinner,
  BDropdown,
  BDropdownDivider,
  BDropdownItem,
  BDropdownForm,
  BFormGroup,
  BFormRadioGroup,
  BFormRadio,
  BCardHeader,
  BCardBody,
  BCollapse,
  BCard,
  BTab,
  BTabs,
  BFormSelect,
  BFormTextarea,
  BToast,
} from "bootstrap-vue";
import InfiniteLoading from "vue-infinite-loading";
import NAsyncSingleSelect from "@/components/NAsyncSingleSelect";
import { bus } from "@/libs/bus";
import Repository from "@/repositories/RepositoryFactory";
import CSwitch from "@/components/chat-input-components/CSwitch";
import GTicketFormModal from "@/components/global-components/GTicketFormModal";
import GEditableProfileInfo from "@/components/global-components/GEditableProfileInfo";
import TicketRepository from "@/repositories/Api/TicketRepository";
import EditableLabel from "@/components/global-components/EditableLabelChatPage.vue";
import useTicketStore from "@/store-pinia/useTicketStore";
import TicketHistory from "@/views/ticket/ticketRightSidebar/ticketHistory.vue";
import CustomerProfileRepository from "@/repositories/Api/CustomerProfileRepository";
import { onMounted } from "@vue/composition-api";
import Toast from "@/libs/toast";
import useJwt from "@/auth/jwt/useJwt";
import ChatActiveChatContentDetailsSidedbar from "./GChatActiveChatContentDetailsSidedbar.vue";
import TreeNode from "./GTreeNode.vue";
import ChatContact from "./GChatContact.vue";

const QuickMessageRepository = Repository.get("quickMessage");
const ChatChannelRepository = Repository.get("chatChannel");
export default {
  name: "PrivateChatRightSidebar",
  components: {
    TicketHistory,
    EditableLabel,
    GEditableProfileInfo,
    GTicketFormModal,
    CSwitch,
    // BSV
    BTab,
    BTabs,
    BAvatar,
    BInputGroup,
    BInputGroupPrepend,
    BFormInput,
    BButton,
    BForm,
    BSpinner,
    BDropdown,
    BDropdownDivider,
    BDropdownItem,
    BDropdownForm,
    BFormGroup,
    BFormRadioGroup,
    BFormRadio,

    BCardHeader,
    BCardBody,
    BCollapse,
    BCard,
    BFormSelect,
    BFormTextarea,
    BToast,

    // 3rd party
    InfiniteLoading,

    // SFC
    ChatContact,
    NAsyncSingleSelect,

    // Tree
    TreeNode,
    ChatActiveChatContentDetailsSidedbar,
  },

  props: {
    sendTextMessage: {
      type: Function,
      require: true,
    },
    mqShallShowRightSidebar: {
      type: Boolean,
      required: true,
    },
    connectionStatus: {
      type: Boolean,
      default: true,
    },
    channels: {
      type: Array,
      default: () => [],
    },
    activeRoom: {
      type: Object,
      default: () => {},
    },
    profileId: {
      type: String,
      default: null,
    },
  },
  data() {
    return {
      data: JSON.parse(
        localStorage.getItem(useJwt.jwtConfig.storageUserDataKeyName)
      ),
      visible: true,
      visiblePersonal: true,
      loading: false,
      isShowSearch: true,
      items: [],
      originItems: [],
      filterOptions: [
        {
          value: "public",
          textTeam: this.$t("button.team"),
        },
        {
          value: "private",
          textPersonal: this.$t("button.personal"),
        },
      ],
      tabOptions: [
        {
          value: "public",
          text: "QuickMessage",
        },
        {
          value: "private",
          text: "profile",
        },
      ],
      query: {
        filter: "public",
        search: "",
      },
      selected: null,
      visitorInformation: {},
      chatMeTicketHistory: [],
      tabIndex: 0,
    };
  },

  computed: {
    userData() {
      return this.$store.state.profile.email || this.$store.state.profile.phone  
        ? this.$store.state.profile
        : JSON.parse(
            localStorage.getItem(useJwt.jwtConfig.storageUserDataKeyName)
          );
    },
    statusLabel() {
      // Status Label
      //   OPEN: 1,
      //   RESOLVED: 2,
      //   PENDING: 3,
      // console.log('status', this.activeRoom)
      switch (this.activeRoom.state) {
        case "1":
          return this.$t("ticket.open");
        case "2":
          return this.$t("ticket.resolved");
        case "3":
          return this.$t("ticket.pending");
        default:
          return "Unknown";
      }
    },
  },
  watch: {
    activeRoom: {
      handler(newValue) {
        if (newValue.incomingCallContext) return;

        this.getChatMeTicketHistory(newValue.roomId);
        // this.getVisitorInformation(newValue.roomId);
      },
      deep: true,
    },
    mqShallShowRightSidebar(value) {
      if (value) {
        this.list();
      }
    },
  },

  created() {},
  methods: {
    openProfile(index) {
      this.tabIndex = index;
    },
    getTicketInfo(profile) {
      // if (profile.id) this.getVisitorTicketHistory(profile.id);
      // if (profile.id) this.getVisitorInformation(profile.id);
    },
    getProfile(profile) {
      return profile?.id;
    },
    makeSuccessToast(append = false) {
      Toast.fire({
        icon: "success",
        title: this.$t("ticket.create_ticket_successfully_message"),
      });
    },
    makeFailToast(append = false) {
      Toast.fire({
        icon: "error",
        title: this.$t("ticket.create_ticket_failed_message"),
      });
    },
    async handleSubmitRespond(response) {
      // const result = await ticketStore.createTicketAsync(createForm, ticketStore.getSelectedTicketDetailCustomerID)
      if (response) {
        this.makeSuccessToast(true);
        this.getChatMeTicketHistory(this.activeRoom.roomId);
      } else {
        this.makeFailToast(true);
      }
    },

    getVisitorInformation(visitorId) {
      this.loading = true;
      if (!visitorId) return;

      CustomerProfileRepository.getProfile(visitorId)
        .then((res) => {
          const { data } = res.data;
          // console.log(data)
          this.visitorInformation = data;
          this.loading = false;
        })
        .catch((e) => {
          this.loading = false;
          // console.log(e)
        });
    },
    getChatMeTicketHistory(roomId) {
      TicketRepository.getChatMeTicketsHistory(roomId)
        .then((res) => {
          const list = res?.data?.data || [];
          if (list.length >= 1) this.chatMeTicketHistory = list;
        })
        .catch((e) => {
          // console.log(e)
        });
    },
    list() {
      if (this.originItems.length > 0) return;
      this.loading = true;
      QuickMessageRepository.show()

        .then((response) => {
          this.originItems = response.data;
          this.$nextTick(() => {
            this.changeFilter();
          });
        })
        .catch()
        .then(() => {
          this.loading = false;
        });
    },
    buildTree(list, deleteNoChildren = true) {
      const map = {};
      let node;
      let roots = [];
      let i;

      for (i = 0; i < list.length; i += 1) {
        list[i] = { ...list[i] };
        map[list[i].id] = i;
        list[i].parentId = list[i].parent;
        list[i].children = [];
      }

      for (i = 0; i < list.length; i += 1) {
        node = list[i];
        if (node.visible) {
          if (node.parent && list[map[node.parent]]) {
            list[map[node.parent]].children.push(node);
          } else {
            roots.push(node);
          }
        }
      }

      if (deleteNoChildren) {
        roots = roots.filter((e) => e.children.length > 0 || e.parentId);
      }

      return roots;
    },
    changeFilter(filter = null) {
      if (filter) {
        this.query.filter = filter;
      }
      const filterItems = this.originItems
        .map((e) => ({ ...e }))
        .filter(
          (e) =>
            e.accessSpecifier == this.query.filter &&
            (!this.query.search.trim() ||
              e.title.toLowerCase().includes(this.query.search.toLowerCase()) ||
              e.description
                ?.toLowerCase()
                .includes(this.query.search.toLowerCase()))
        );
      this.items = this.buildTree(filterItems);
    },
    searching() {
      this.isShowSearch = !this.isShowSearch;
      if (!this.isShowSearch && this.query.search) {
        this.query.search = "";
        this.search();
      }
    },
    search() {
      this.changeFilter();
    },
    linkClass(idx) {
      // if (this.tabIndex === idx) {
      //   return ["bg-primary", "text-light"];
      // }
      // return ["bg-light", "text-info"];
    },
    editCustomerName() {},
    updateCustomerName() {},
    // getTicketHistoryForCustomer() {
    //   TicketRepository.GetTicketHistory(this.activeRoom.customer?.id)

    //     .then((response) => {
    //       // console.log('history', response.data.data)
    //     })
    //     .catch((error) => {
    //       // console.log(error)
    //     });
    // },
  },
  setup() {
    const ticketStore = useTicketStore();

    onMounted(() => {
      ticketStore.getCreateTicketOptionAsync();
    });

    return { ticketStore };
  },
};
</script>

<style lang="scss" scoped>
.active {
  //padding-right: 8em;
}

.in-active {
  //padding-right: 0;
}

.sidebar-right {
  //overflow-y: scroll;
  //overflow-x: hidden;

  .sidebar-content {
    border-right: 0;
    border-left: 1px solid #ebe9f1;
    height: 100%;
    overflow: auto;

    &.right-sidebar-content {
      transition: all 0.2s linear;
      display: block;
      //padding-right: 8em;

      &.zero-width {
        width: 0px !important;
        //padding-right:0
      }
    }
  }
}

.card .card-header {
  position: relative;
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  justify-content: revert;
  // margin-top:10px;
}

[dir] .card-body {
  padding: 1.5rem;
  padding-top: 0rem !important;
}

[dir] .accordion > .card > .card-header {
  border-radius: 0;
  // margin-bottom: -18px;
}

[dir] .nav-tabs {
  padding-left: 0.75em;
  padding-right: 0.75em;
  margin-bottom: 0;
  padding-top: 0.75em;
}
</style>
